<template>
  <div id="blank"></div>
</template>

<script>
export default {
  created: function() {
    if (this.$route.query.value == "classtext") {
      // alert(this.$store.state.store.is_project)
      if (this.$store.state.store.is_project == "0") {
        this.$router.push({
          path: "/classsearch",
          query: {
            data: this.$route.query.data,
            value: "classtext"
          }
        });
      } else {
        this.$router.push({
          path: "/projectlist",
          query: {
            data: this.$route.query.data,
            value: "classtext"
          }
        });
        // alert(this.$route.query.data)
      }
      // this.$router.push({
      //   path: "/classsearch",
      //   query: {
      //     data: this.$route.query.data,
      //     value: "classtext"
      //   }
      // });
    } else if (this.$route.query.lableType == "secondLable") {
      this.$router.push({
        path: "/classsearch",
        query: {
          firstId: this.$route.query.firstId,
          secondId: this.$route.query.secondId,
          lableType: this.$route.query.lableType
        }
      });
    } else if (this.$route.query.lableType == "firstLable") {
      this.$router.push({
        path: "/classsearch",
        query: {
          firstId: this.$route.query.firstId,
          lableType: this.$route.query.lableType
        }
      });
    } else if (this.$route.query.lableType == "zeroLable") {
      this.$router.push({
        path: "/classsearch",
        query: {
          zeroId: this.$route.query.zerotId,
          lableType: this.$route.query.lableType
        }
      });
    }
  },
  mounted: function() {}
};
</script>

